__turbopack_context__.v({
  "destructive": "ListItem-module__i4dWXG__destructive",
  "disabled": "ListItem-module__i4dWXG__disabled",
  "highlighted": "ListItem-module__i4dWXG__highlighted",
  "icon": "ListItem-module__i4dWXG__icon",
  "label": "ListItem-module__i4dWXG__label",
  "meta": "ListItem-module__i4dWXG__meta",
  "root": "ListItem-module__i4dWXG__root",
  "trailingIcon": "ListItem-module__i4dWXG__trailingIcon",
});
